import { render, staticRenderFns } from "./cardBtn.vue?vue&type=template&id=012f75e8&scoped=true"
import script from "./cardBtn.vue?vue&type=script&lang=js"
export * from "./cardBtn.vue?vue&type=script&lang=js"
import style0 from "./cardBtn.vue?vue&type=style&index=0&id=012f75e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f75e8",
  null
  
)

export default component.exports